import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>FireGram</h1>
      <h2>Your Pictures</h2>
      <p>Welcome to firegram. Project done and completed by Daniekeys </p>
      <p>Version 1.0</p>
    </div>
  )
}

export default Title;